<template>
  <div
    class="cat-review-section"
    :role="label ? 'region' : null"
    :aria-label="label ? label : null"
    :data-label="label ? label : null"
  >
    <div class="review-section-top">
      <div class="review-section-heading-wrapper">
        <h3 v-if="label" class="review-section-heading">
          <a
            aria-hidden="true"
            :data-button="label"
            role="button"
            @click="select"
            >{{ label }}</a
          >
        </h3>
        <cat-pill
          v-if="badge"
          :level="badge.type"
          :value="badge.value"
          :class="badge.css"
        ></cat-pill>
      </div>
      <cat-alert-marker
        v-if="incompleteMarker"
        :id="incompleteMarker.id"
        :type="incompleteMarker.type"
        :markerText="incompleteMarker.message"
        :offscreenMarkerText="incompleteMarker.offscreenMessage"
        :markerTextClass="incompleteMarker.style"
      >
      </cat-alert-marker>
      <slot name="actions"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CatAlertMarker from "@/components/utilities/catAlertMarker";
export default defineComponent({
  name: "ReviewSection",
  components: { CatAlertMarker },
  props: {
    label: [String],
    selectFn: [Function],
    index: [Number],
    incompleteMarker: {
      type: Object,
      description:
        "Object with the following properties - type (errors, warning, info, debug), message, offscreenMessage, style (css styling). Eg. { type: 'error', message: 'Incomplete', offscreenMessage: 'This section is incomplete. Please edit.' }"
    },
    warnings: [Boolean],
    badge: {
      type: Object,
      description:
        "Object with the following properties - type (errors, warning, info, debug), value, css, . Eg. { type: 'error', value: 'Incomplete', css: 'mrt' }"
    }
  },
  inject: {
    resolveTxt: { name: "resolveTxt", default: (key, def) => def }
  },
  provide: function () {
    return {
      headingLevel: 3
    };
  },
  methods: {
    select: function () {
      this.selectFn({
        value: this.index + 1
      });
    }
  }
});
</script>
